export default __webpack_public_path__ + "static/media/image-5.96c9e83a.png";